import React from "react";
import classNames from "classnames";
import Icon from "../../elements/icon";
import "./style.scss";

const chevronLeftIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87"/><path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"/></svg>';
const chevronRightIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87"/><path d="M6.49 20.13l1.77 1.77 9.9-9.9-9.9-9.9-1.77 1.77L14.62 12l-8.13 8.13z"/></svg>';

const Carousel = ({ className, onPrev, onNext, children }) => {
  const carouselClasses = classNames("carousel", className);
  return (
    <div className={carouselClasses}>
      <div className="prev">
        <button className="button-prev" onClick={() => onPrev()}>
          <Icon
            icon={{
              ...{
                alt: chevronLeftIcon
              }
            }}
          />
        </button>
      </div>

      {children}

      <div className="next">
        <button className="button-next" onClick={onNext}>
          <Icon
            icon={{
              ...{
                alt: chevronRightIcon
              }
            }}
          />
        </button>
      </div>
    </div>
  );
};

export default Carousel;
